import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PropertyState } from "./property.reducer";


export const selectPropertyState = createFeatureSelector<PropertyState>('property');

export const selectResumeData = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.data
);

export const selectQuotePhoneList = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.data ? state.data.quotePhoneList : null
);

export const selectQuoteId = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.data ? state.data.quoteId : null
);

export const selectsessionId = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.data ? state.data.sessionId : null
);


export const selectQuestion = createSelector(selectPropertyState, (state: PropertyState) => state.data ? state.data.question : undefined);

export const selectResumeError = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.error
);

export const selectCountResend = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.data ? state.data.countResend : null
);
export const selectQuoteIdAndApplicationId = createSelector(
    selectPropertyState,
    (state: PropertyState) => ({
        quoteId: state.data?.quoteId ?? null,
        ApplicationId: state.data?.quotePhoneList?.ApplicationId ?? state.data?.question?.ApplicationId ?? 0
    })
);

export const selectActivephone = createSelector(
    selectPropertyState,
    (state: PropertyState) => state.data ? state.data.quotePhoneList?.listPhones.find(phone => phone.isSelect)?.mobilePhoneNumber : null
);
